import { Outlet } from "react-router-dom";
import { Navigation, LanguageSelector, Footer } from "../../components";
import style from "./Appointment.module.scss";
import {Container} from '../../components/HOC/container'
import { useTranslation } from "../../shared/hooks/useTranslation";

const current = [
  {
    path: "/service",
    current: 0,
  },
  {
    path: "/service/",
    current: 1,
  },
  {
    path: "/doctor",
    current: 1,
  },
  {
    path: "/form",
    current: 2,
  },
  {
    path: "/schedule",
    current: 3,
  }
];

export function Appointment() {
  const { t } = useTranslation();

  const items = [
    {
      title: t.step1,
    },
    {
      title: t.step2,
    },
    {
      title: t.step3,
    },
  ]

  return (
    <div className={style.page}>
      <header className={style.header}>
        <div className={style.headerInner}>
          <div className={style.headerLogoWrap}>
            <img src="/logo.svg" alt="UMC" className={style.headerLogo} />
          </div>
          <h1 className={style.title}>{t.title}</h1>
          <div className={style.headerRight}>
            <LanguageSelector />
          </div>
        </div>
        <div className={style.stepsWrap}>
          <Navigation items={items} current={current} />
        </div>
      </header>
      <Container section className={style.container}>
        <div className={style.outlet}>
          <Outlet />
        </div>
      </Container>

      <Footer />
    </div>
  );
}
